const PREFIX = "[schedule-save-perf]"

export function isScheduleSavePerfEnabled() {
    if (typeof process !== "undefined" && process.env.NODE_ENV === "test") {
        return false
    }
    if (typeof import.meta === "undefined" || !import.meta.env) {
        return false
    }
    return Boolean(import.meta.env.DEV)
}

/**
 * @param {string} label
 * @param {Record<string, unknown>} [data]
 */
export function logScheduleSavePerf(label, data = {}) {
    if (!isScheduleSavePerfEnabled()) return
    console.log(PREFIX, label, data)
}

/**
 * @template T
 * @param {() => T} fn
 * @param {string} label
 * @param {Record<string, unknown>} [extra]
 * @returns {T}
 */
export function timeScheduleSavePerf(fn, label, extra = {}) {
    if (!isScheduleSavePerfEnabled()) return fn()

    const start = performance.now()
    const result = fn()
    logScheduleSavePerf(label, { ...extra, durationMs: Math.round(performance.now() - start) })
    return result
}
